module.exports = __webpack_public_path__ + "img/sxhb_file.0f3ed1c4.png";